import { fromUtcString, toUtcString } from '@/lib/dateUtils';
import type { DatePickerProps } from './types';

const DATE_TIME_FIELD_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const defaultFromFormikValue = (value: unknown) =>
  fromUtcString(value as string | null) as DatePickerProps['value'];

export const defaultToFormikValue: NonNullable<DatePickerProps['toFormikValue']> = (dateString, date) => {
  if (date) {
    return toUtcString(date.format(DATE_TIME_FIELD_FORMAT));
  }

  return toUtcString(Array.isArray(dateString) ? dateString[0] : (dateString ?? null));
};
